var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('code',{staticClass:"text-xs text-gray-600"},[_vm._v(" "+_vm._s(_vm.env.VUE_APP_ENV === 'staging' || _vm.env.VUE_APP_ENV === 'development' ? ((_vm.env.VUE_APP_ENV) + "-" + (_vm.env.VERSION)) : null)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }